import { Box, Typography } from "@mui/material";
import useColors from "../../../../../../../../../api/hooks/useColors";
import CustomTooltip from "../../../../../../../../../components/CustomTooltip";
import StyledDataGrid from "../../../../../../../../../components/StyledDataGrid";
import iconMapping from "../../../../../../../../../icons/IconMapping";
import SvgToIcon from "../../../../../../../../../icons/SvgToIcon";
import { ReactComponent as CriticalAssetIcon } from "../../../../../../../../../scenes/stack/environment/icons/critical-asset-20-currentColor.svg";
import { getEntityTypeDisplayName } from "../../../../../../../../../utils/utils";
import { getWizardTableStyle } from "./utils";

export default function NonGroupedControlEntitiesTable({
  rows,
  selectedEntityIDsMapping,
  setSelectedEntityIDsMapping,
}) {
  const colors = useColors();

  const columns = [
    {
      field: "isCriticalAsset",
      headerName: "",
      hideHeader: true,
      align: "center",
      width: 80,
      sortable: false,
      resizable: false,
      disableReorder: true,
      renderCell: (params) => (
        <SvgToIcon
          IconLogo={CriticalAssetIcon}
          width="13px"
          style={{
            color: params.value
              ? colors.icon_action_selected
              : colors.icon_action_disabled,
          }}
        />
      ),
    },
    {
      field: "entityType",
      headerName: "Type",
      headerAlign: "center",
      align: "center",
      minWidth: 80,
      sortable: true,
      resizable: true,
      disableReorder: true,
      renderCell: (params) => {
        const Icon = iconMapping[params.value] || iconMapping["Internet"];
        const entityTypeDisplayName = getEntityTypeDisplayName(params.value);
        return (
          <CustomTooltip title={entityTypeDisplayName}>
            <Box>
              <Icon
                style={{
                  color: colors.text_primary,
                  width: "20px",
                  height: "20px",
                }}
              />
            </Box>
          </CustomTooltip>
        );
      },
    },
    {
      field: "displayName",
      headerName: "Name",
      headerAlign: "left",
      align: "left",
      flex: 1,
      minWidth: 90,
      sortable: true,
      resizable: true,
      disableReorder: true,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              overflow: "hidden",
            }}
          >
            <Typography variant="caption" color={colors.grey_700}>
              {params.value}
            </Typography>
          </Box>
        );
      },
    },
  ];

  return (
    <StyledDataGrid
      boxSXProps={{
        minHeight: "300px",
        borderRadius: "10px",
        ".MuiDataGrid-root": {
          border: "none",
          boxShadow: "none",
        },
        ".MuiDataGrid-main": {
          minHeight: "300px",
        },
      }}
      getRowId={(row) => row.entityId}
      getRowHeight={() => "auto"}
      checkboxSelection
      disableColumnMenu
      sx={getWizardTableStyle(colors)}
      columns={columns}
      rows={rows}
      rowSelectionModel={Object.keys(selectedEntityIDsMapping)}
      onRowSelectionModelChange={(newSelectionModel) => {
        setSelectedEntityIDsMapping(
          newSelectionModel.reduce((acc, entityId) => {
            acc[entityId] = [];
            return acc;
          }, {})
        );
      }}
      pageSizeOptionsOverride={[5, 10, 20]}
    />
  );
}
